<app-loader *ngIf="!dataIsLoaded"></app-loader>
<section class="navbar-brand">
	<img src="../../assets/img/{{themeService.theme}}/scd-logo.png" alt="Company Logo" width="125px">
</section>
<section class="main-side-plan-review">
	<section class="plan-review-container">
		<section class="plan-review-steps">
			<div class="box-step-count">
				<div class="box-count" [ngClass]="{stepActived:currentStep=='my-assets'}"
					(click)="setCategory('my-assets')">1
				</div>
				<div class="box-count" [ngClass]="{stepActived:currentStep=='my-debts'}"
					(click)="setCategory('my-debts')">2
				</div>
				<div class="box-count" [ngClass]="{stepActived:currentStep=='my-daily-life'}"
					(click)="setCategory('my-daily-life')">3
				</div>
				<div class="box-count" [ngClass]="{stepActived:currentStep=='my-digital-life'}"
					(click)="setCategory('my-digital-life')">4
				</div>
				<div class="box-count" [ngClass]="{stepActived:currentStep=='my-wishes'}"
					(click)="setCategory('my-wishes')">5
				</div>
			</div>
			<div class="step-count">Step {{stepNumber}}</div>
			<div class="title">Review Your {{categoryName}}</div>
			<div class="svg-containerr ">
				<div class="title-img" *ngIf="currentStep==null">
					<!-- Assets  -->
					<img src="../../assets/img/{{themeService.theme}}/assets.svg" alt="Assets" width="150px">
				</div>
				<!-- Assets  -->
				<div class="title-img" *ngIf="currentStep=='my-assets'">
					<img src="../../assets/img/{{themeService.theme}}/assets.svg" alt="Assets" width="150px">
				</div>
				<!-- Debts  -->
				<div class="title-img" *ngIf="currentStep=='my-debts'">
					<img src="../../assets/img/{{themeService.theme}}/debts.svg" alt="Debts" width="150px">
				</div>
				<!-- Daily Life -->
				<div class="title-img" *ngIf="currentStep=='my-daily-life'">
					<img src="../../assets/img/{{themeService.theme}}/daily-life.svg" alt="Daily Life" width="150px">
				</div>
				<!-- Digital Life -->
				<div class="title-img" *ngIf="currentStep=='my-digital-life'">
					<img src="../../assets/img/{{themeService.theme}}/digital-life.svg" alt="Digital Life" width="150px">
				</div>
				<!-- Wishes  -->
				<div class="title-img" *ngIf="currentStep=='my-wishes'">
					<img src="../../assets/img/{{themeService.theme}}/wishes.svg" alt="Wishes" width="150px">
				</div>
			</div>
			<div class="subtitles">
				{{categoryDescription}}
			</div>
		</section>

		<section class="container plan-review-categories">
			<app-category-box (deletedItem)="showItemDeleted($event)" [categoryContent]="categoryContent"
				[planCategory]="planCategory" [categorySections]="myFormTemplate && myFormTemplate.cards">
			</app-category-box>
			<div *ngIf="dataIsLoaded" class="plan-review-next-step" (click)="setCategoryByStep(stepNumber)">
				{{stepButtonText}}</div>
		</section>
	</section>
</section>